import {
  SCROLL_TO_PRICE,
  SCROLL_TO_REVIEWS,
  SCROLL_TO_SECTION,
  TOGGLE_SHORT_INFO,
  SHOW_PAGE,
  SET_SEARCH_TYPE,
} from '../constants/view';

export const scrollToPriceAction = () => ({
  type: SCROLL_TO_PRICE,
});

export const scrollToReviewsAction = () => ({
  type: SCROLL_TO_REVIEWS,
});

export const scrollToSectionAction = (payload) => ({
  type: SCROLL_TO_SECTION,
  payload,
});

export const toggleShortInfoAction = () => ({
  type: TOGGLE_SHORT_INFO,
});

export const showPageAction = (payload) => ({
  type: SHOW_PAGE,
  payload,
});

export const setSearchTypeAction = (payload) => ({
  type: SET_SEARCH_TYPE,
  payload,
});
